export default __webpack_public_path__ + "static/media/Health.39c90c39.svg";